import PartNumberCard from "./partnumbercard"
import React, { useState, useEffect } from 'react';
import { ContainerIprops } from "./partnumberinterface";
import helperfunctions from "../../../utils/helperfunctions";
import { ICartContextType } from "../ShoppingCartPromo/shoppingcartpromointerface";
import { useCartContext } from "../shoppingcart";
import { selectors as headerSelector } from '../../../state/features/header';
import partsService from "../../../services/partsservice";
import { selectors as globalDataSelector, operations as commondataoperations } from "../../../state/features/common/globaldata";
import { useDispatch, useSelector } from "react-redux";

const PartNumberCardContainer = (props: ContainerIprops) => {
    const { cartsDetails }: ICartContextType = useCartContext();
    const [branchInfo, setBranchInfo] = useState({ loading: false, data: {} });
    const [branchDetailsModal, setBranchDetailsModal] = useState(false);
    const [dealerView, setDealerView] = useState(false);
    const [selectedBranch, setSelectedBranch] = useState<any>({})
    const [delearBranchList, setDelearBranchList] = useState<any>({ data: [], loading: false });
    const dispatch = useDispatch();
    const dispatchsetGlobalData = commondataoperations.dispatchCurrentGlobalData(dispatch);

    const {
        headercurrentuser,
        globalData
    }: any = useSelector(
        state => ({
            headercurrentuser: headerSelector.currentuser(state),
            globalData: globalDataSelector.globaldata(state)
        })
    );

    useEffect(() => {
        if (globalData) {
            setSelectedBranch({
                BranchName: globalData?.BranchName,
                BranchCode: globalData?.BranchCode,
            })
        }
    }, [globalData?.BranchCode])

    const onhandleClose = () => {
        setBranchDetailsModal(false);
    }

    const getBranchInfo = async () => {
        try {
            setBranchInfo({ loading: true, data: {} });
            const reqBody = {
                cartId: cartsDetails?.cart?.cartId ?? 0,
                userAadId: headercurrentuser?.azureADId ?? '',
            }
            const response = await partsService.getFullfilmentBranchInfo(reqBody);
            if (response?.isSuccess) {
                setBranchInfo({ loading: false, data: response?.data ?? {} });
            } else {
                setBranchInfo({
                    loading: false, data: {}
                });
                helperfunctions.showErrorMessage(`${response?.msg}`);
            }
        } catch (error) {
            setBranchInfo({
                loading: false, data: {}
            });
            helperfunctions.showErrorMessage(`${error}`);
        }
    };

    const closeDealerAvailablity = (isRefresh: boolean) => {
        if (isRefresh) {
            if (selectedBranch?.BranchCode !== 'Select') {
                dispatchsetGlobalData(selectedBranch);
            }
        } else {
            setSelectedBranch({
                BranchName: globalData?.BranchName,
                BranchCode: globalData?.BranchCode,
            })
        }
        setDealerView(false);
    }

    const getDelearBranchAvailability = async (item: any, part: any) => {
        try {
            setDelearBranchList({ loading: true, data: [] });
            const reqBody = {
                cartId: cartsDetails?.cart?.cartId ?? 0,
                partNumber: item?.partNumber ?? '',
                manufacturerCode: part?.manufacturer?.code ?? '',
                userAadId: headercurrentuser?.azureADId ?? ''
            }
            const response = await partsService.getDelearBranchAvailability(reqBody);
            const res = response?.data?.length > 0 ? response?.data.reduce((acc: any, item: any): any => {
                acc.push({
                    ...item,
                    title: item?.branchLocation,
                    value: item?.distributorBranchCode,
                    branchAvailability: item?.branchAvailability ? Number(item?.branchAvailability) : 0,
                });
                return acc;
            }, []) : [];
            if (response?.isSuccess) {
                setDelearBranchList({ loading: false, data: res ?? [] });
            } else {
                setDelearBranchList({ loading: false, data: [] });
                helperfunctions.showErrorMessage(`${response?.msg}`);
            }
        } catch (error) {
            setDelearBranchList({ loading: false, data: [] });
            helperfunctions.showErrorMessage(`${error}`);
        }
    }

    const openGmap = (row: any) => {
        if (row?.gMapUrl) {
            window.open(row?.gMapUrl, '_blank');
        }
    }

    const dealerOnClick = (item: any, part: any) => {
        if (item?.type && item?.type?.toLowerCase() === 'da') {
            setDealerView(true);
            getDelearBranchAvailability(item, part)
        }
    }

    const onClickContactDealer = () => {
        setBranchDetailsModal(true)
        getBranchInfo();
    }

    const onOrderingBranchChange = (value: any, title: any) => {
        setSelectedBranch({
            BranchName: title?.length > 0 ? title[0] : title,
            BranchCode: value,
        })
    }

    return (
        <PartNumberCard setMachineManufactureModel={props.setMachineManufactureModel}
            onClickContactDealer={onClickContactDealer}
            branchDetailsModal={branchDetailsModal}
            onhandleClose={onhandleClose}
            branchInfo={branchInfo}
            dealerOnClick={dealerOnClick}
            dealerView={dealerView}
            closeDealerAvailablity={closeDealerAvailablity}
            openGmap={openGmap}
            onOrderingBranchChange={onOrderingBranchChange}
            delearBranchList={delearBranchList}
            selectedBranch={selectedBranch}
            isFetchingCartItems={props?.isFetchingCartItems}
            handleManufactureOption={props?.handleManufactureOption}
            updateCartQuantity={props.updateCartQuantity} setCartDetails={props.setCartDetails} partNumberRedirect={props.partNumberRedirect} partnumberchild={props.partnumberchild} cartsDetails={props.cartsDetails} productRecommendationPopupClick={props.productRecommendationPopupClick} toggleManufacturePopupClick={props.toggleManufacturePopupClick} manufacturePopup={props.manufacturePopup} toggleMachinePopupClick={props.toggleMachinePopupClick} isMachine={props.isMachine} manufactureValue={props.manufactureValue} machineValue={props.machineValue} ReturnableOnClick={props.ReturnableOnClick} estOnClick={props.estOnClick}
            handleChildChange={props.handleChildChange} childCheckboxes={props.childCheckboxes} refreshCartRequiredParts={props?.refreshCartRequiredParts}
        />
    )
}
export default PartNumberCardContainer